import { computed } from 'vue';
import { useStore } from './useStore';

export function useTranslationStates() {
    const {
        lang,
        langType,
        userPreferredLangOptions,
        switchTranslateLanguage,
        setUserPreferredLangOptions,
        switchMachineTrans,
        setSideTransStatus,
    } = useStore();

    const currentTranslateLanguages = computed(() => {
        return lang.value;
    });

    const currentLanguageModes = computed(() => {
        return langType.value;
    });

    return {
        /**
         * 当前翻译语言
         * @description 同 'root/lang'
         */
        currentTranslateLanguages,
        /**
         * 当前语言模式（默认/翻译/原文）
         * @description 同 'root/langType'
         */
        currentLanguageModes,
        /**
         * 左右视图的语言选项（翻译语言+预言模式）
         */
        userPreferredLangOptions,
        /**
         * @description 同 'root/setLang'
         */
        switchTranslateLanguage,
        /**
         * @description 同 'root/setUserPreferredLangOption'
         */
        setUserPreferredLangOptions,
        /**
         * @description 同 'root/setIsMachineTrans'
         */
        switchMachineTrans,
        setSideTransStatus,
    };
}
